import LegalShell, { Section, MailLink } from "@/components/LegalShell";

export default function EditorialPolicy() {
  return (
    <LegalShell kicker="Editorial" title="Editorial Policy" updated="29 October 2026" testId="editorial-page" path="/editorial-policy" docTitle="Editorial Policy · Astra">
      <Section title="1. How we create horoscopes">
        <p>(a) Calculate — we compute real-time planetary positions using PyEphem / VSOP87. (b) Interpret — Anthropic's Claude, guided by our astrology instruction set, drafts the interpretation based on that calculation. Western tropical only. (c) Review — human editors spot-check for quality and duplication.</p>
      </Section>
      <Section title="2. AI Disclosure">
        <p>We use AI to assist in drafting at scale. AI does not calculate planets; it interprets calculations we provide. We maintain human oversight through spot-checks, template review, and review of weekly/monthly content. Daily readings auto-publish and are sampled for quality.</p>
      </Section>
      <Section title="3. What we publish">
        <p>Daily, Love, Money for each sign, plus weekly and monthly. We also publish 8 daily planet pages (live positions calculated with PyEphem, with a daily note) and 78 sign-pair compatibility guides. We do not currently publish Chinese BaZi or Pythagorean numerology.</p>
      </Section>
      <Section title="4. Corrections & Entertainment Disclaimer">
        <p>If a calculation error is found we correct it. Horoscopes are for entertainment only, not medical, financial or legal advice. Contact <MailLink subject="Correction" /> for corrections.</p>
      </Section>
    </LegalShell>
  );
}
